import { useApiUrl, useUpdateMany } from '@refinedev/core';

import { FlexPackage } from '../types';
import httpClient from '../utils/axios';

interface PaginatedResponse<T> {
  results: T[];
}

const useDeselectFeaturedPackages = () => {
  const apiUrl = useApiUrl();
  const { mutateAsync: updateManyAsync } = useUpdateMany();

  const deselectFeaturedPackages = async ({
    onFinish,
    onError
  }: {
    onFinish?: () => void;
    onError?: (e: unknown) => void;
  }) => {
    try {
      const { data } = await httpClient.get<PaginatedResponse<FlexPackage>>(`${apiUrl}/flex_packages`, {
        params: { featured: true, page_size: 10000 }
      });

      await updateManyAsync({
        resource: 'flex_packages',
        ids: data.results.map(pkg => pkg.id),
        values: { featured: false }
      });
    } catch (e) {
      onError?.(e);
    } finally {
      onFinish?.();
    }
  };

  return deselectFeaturedPackages;
};

export default useDeselectFeaturedPackages;
